import React, { useRef } from "react";
import { Card } from "@curves/ui-base";
import { TermContent } from "@icoach/documents/components";
import terms from "@icoach/documents/membership/quit/version104/terms";
import { Grid } from "@mui/material";
import { ReadTextField } from "@icoach/components";
import { displayDateText } from "@util/moment";
import { formatCurrencyFn } from "@util/utils";
import MembershipDocumentDialogBox from "@icoach/documents/membership/dialog/MembershipDocumentDialogBox";
import WorkspaceBox from "@icoach/documents/membership/quit/components/WorkspaceBox";
import MembershipQuitForm104 from "@icoach/documents/membership/quit/version104/MembershipQuitForm104";
import FocusModeToggle from "@icoach/components/FocusModeToggle";


const contractInfo = [
	{
		key: "paymentTypeText",
		text: "付款方式",
		formatter: (value) => value,
		grid: 4
	},
	{
		key: "monthlyFee",
		text: "月費",
		formatter: (value) => formatCurrencyFn(value),
		grid: 4
	},
	{
		key: "joinFee",
		text: "入會費",
		formatter: (value) => formatCurrencyFn(value),
		grid: 4
	},
	{
		key: "membershipTermText",
		text: "合約長度",
		formatter: (value) => value,
		grid: 4
	},
	{
		key: "membershipPeriod",
		text: "會籍期間",
		formatter: (_, data) => displayDateText(data.startDate, data.endDate),
		grid: 8
	}
];


const MembershipQuitContract104 = ({ sourceData, peopleType, contractID, referenceID, isReadOnly }) => {
	const { membership } = sourceData || {};
	const contractInfoWithData = { ...membership, joinFee: sourceData?.joinFee };

	const dialogRef = useRef(null);
	const focusModeRef = useRef(null);

	return (
		<>
			<FocusModeToggle ref={focusModeRef} showToggleFocusModeButton={!isReadOnly}>
				<TermContent title={"會員權終止條款"} subheader="依教育部體育署健身中心定型化契約" sourceData={terms}
							 className="mb-3" />
				<Card className="mb-3">
					<Card.CardHeader title="合約方案" className="bg-light text-center" />
					<Card.CardContent className="px-4 py-5">
						<Grid container spacing={2}>
							{
								contractInfo.map(({ key, text, formatter, grid }) => (
									<Grid item xs={grid} key={key}>
										<ReadTextField
											label={text}>{formatter(contractInfoWithData?.[key], contractInfoWithData)}</ReadTextField>
									</Grid>
								))
							}
						</Grid>
					</Card.CardContent>
				</Card>
				<MembershipQuitForm104 sourceData={sourceData} peopleType={peopleType} contractID={contractID}
									   referenceID={referenceID} isReadOnly={isReadOnly} dialogRef={dialogRef}
									   focusModeRef={focusModeRef} />
			</FocusModeToggle>
			{sourceData?.membershipID && sourceData?.memberID ? (
				<WorkspaceBox
					openMembershipRecordDialog={() => dialogRef.current?.openMembershipRecordDialog({
						memberID: sourceData?.memberID,
						membershipID: sourceData?.membershipID
					})}
					openMembershipBillingRecordDialog={() => dialogRef.current?.openMembershipBillingRecordDialog({
						memberID: sourceData?.memberID,
						membershipID: sourceData?.membershipID
					})} />
			) : null}
			<MembershipDocumentDialogBox ref={dialogRef} />
		</>
	);
};

export default MembershipQuitContract104;
